const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1477.07 41.323a8.7 8.7 0 0 1 0-6.647 8.574 8.574 0 0 1 3.66-4.215v3.582h1.42V28.6h-5.38v1.433h2.06a10.2 10.2 0 0 0 .05 15.977 10.018 10.018 0 0 0 4.59 1.99l.21-1.416a8.535 8.535 0 0 1-6.61-5.261Zm17.14.548a10.088 10.088 0 0 0 0-7.743 10 10 0 0 0-7.7-6.128l-.22 1.416a8.551 8.551 0 0 1 6.62 5.261 8.789 8.789 0 0 1 0 6.647 8.624 8.624 0 0 1-3.66 4.215v-3.583h-1.42V47.4h5.38v-1.432h-2.06a9.969 9.969 0 0 0 3.06-4.096Z",
    "data-name": "Forma 1",
    style: {
      fill: "#9a9a9a",
      fillRule: "evenodd"
    },
    transform: "translate(-1475 -28)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.206d225e4f39d24ccd91a5cd8a19e461.svg";
export { ForwardRef as ReactComponent };